export { InstanceController } from './ui/instance-controller';
